import {
    FavoritePersonaNode,
    FavoritePrivateDistributionListNode,
    FolderForestNodeType,
} from 'owa-favorites-types';
import folderStore, { Folder } from 'owa-folders';
import { getSelectedNode } from 'owa-mail-folder-forest-store';

export default function getSelectedFolder(): Folder {
    const selectedNode = getSelectedNode();
    let selectedFolderId = null;

    if (selectedNode.type === FolderForestNodeType.Persona) {
        selectedFolderId = (selectedNode as FavoritePersonaNode).searchFolderId;
    } else if (selectedNode.type === FolderForestNodeType.PrivateDistributionList) {
        selectedFolderId = (selectedNode as FavoritePrivateDistributionListNode).data
            .searchFolderId;
    } else {
        selectedFolderId = selectedNode.id;
    }

    return selectedFolderId == null ? null : folderStore.folderTable.get(selectedFolderId);
}
